import Alert from "react-s-alert";
import RestoreRequest from "../ws/RestoreRequest";
import {I18nUtils} from "../../../i18n/I18nUtils";
import {OUTSOURCE_REMOVE} from "../../outsource/actions/outsourceActions";
import {WORKER_REMOVE} from "../../worker/actions/workerActions";
import {MACHINE_REMOVE} from "../../machines/actions/machineActions";

export const PAPER_BIN_LOADING  = 'paper-bin-loading';

// ACTIONS

export const recoverCompany = (company) => (dispatch) => {

  new RestoreRequest([company.id], [], [])
    .onPreExecution(() => {
      dispatch({ type: PAPER_BIN_LOADING, payload: true });
    })
    .onSuccess(response => {
      if (response.data.errorsByCompany[company.id]) {
        Alert.error(response.data.errorsByCompany[company.id]);
      } else {
        Alert.success(I18nUtils.tr('TR_RESTORE_COMPANY_SUCCESS'));
        dispatch({ type: OUTSOURCE_REMOVE, payload: company.id });
      }
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_RESTORE_COMPANY_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: PAPER_BIN_LOADING, payload: false });
    })
    .execute();

};

export const recoverWorker = (worker) => (dispatch) => {

  new RestoreRequest([], [worker.id], [])
    .onPreExecution(() => {
      dispatch({ type: PAPER_BIN_LOADING, payload: true });
    })
    .onSuccess(response => {
      if (response.data.errorsByWorker[worker.id]) {
        Alert.error(response.data.errorsByWorker[worker.id]);
      } else {
        Alert.success(I18nUtils.tr('TR_RESTORE_WORKER_SUCCESS'));
        dispatch({ type: WORKER_REMOVE, payload: worker.id })
      }
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_RESTORE_WORKER_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: PAPER_BIN_LOADING, payload: false });
    })
    .execute();

};

export const recoverMachine = (machine) => (dispatch) => {

  new RestoreRequest([], [], [machine.id])
    .onPreExecution(() => {
      dispatch({ type: PAPER_BIN_LOADING, payload: true });
    })
    .onSuccess(response => {
      if (response.data.errorsByMachine[machine.id]) {
        Alert.error(response.data.errorsByMachine[machine.id]);
      } else {
        Alert.success(I18nUtils.tr('TR_RESTORE_MACHINE_SUCCESS'));
        dispatch({ type: MACHINE_REMOVE, payload: machine.id })
      }
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_RESTORE_MACHINE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: PAPER_BIN_LOADING, payload: false });
    })
    .execute();

};




// WEBPACK FOOTER //
// ./src/app/paperbin/actions/paperBinActions.js